export const gitCommit = '646dcb2c'
